import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { auth as authApi } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await authApi.me();
      setUser(data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await authApi.login(email, password);
    if (data.session_token) localStorage.setItem("rq_token", data.session_token);
    await checkAuth();
    return data;
  };

  const register = async (payload) => {
    const { data } = await authApi.register(payload);
    if (data.session_token) localStorage.setItem("rq_token", data.session_token);
    await checkAuth();
    return data;
  };

  const logout = async () => {
    try { await authApi.logout(); } catch (_e) { /* ignore */ }
    localStorage.removeItem("rq_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh: checkAuth, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
